(() => {
  const bar = document.querySelector('[data-fp-sticky-atc]');
  if (!bar) return;

  const trigger = document.querySelector('[data-fp-sticky-trigger]');
  const btn = bar.querySelector('[data-fp-sticky-btn]');
  const closeBtn = bar.querySelector('[data-fp-sticky-close]');
  const addedMsg = bar.querySelector('[data-fp-sticky-added]');
  const priceEl = bar.querySelector('[data-fp-sticky-price]');

  if (!trigger || !btn) return;

  let dismissed = false;

  // Show/hide on scroll
  const observer = new IntersectionObserver(([entry]) => {
    if (dismissed) return;
    if (!entry.isIntersecting) {
      bar.classList.add('fp-sticky-atc--visible');
    } else {
      bar.classList.remove('fp-sticky-atc--visible');
    }
  }, { threshold: 0 });

  observer.observe(trigger);

  // Dismiss
  closeBtn?.addEventListener('click', () => {
    dismissed = true;
    bar.classList.remove('fp-sticky-atc--visible');
    setTimeout(() => bar.classList.add('fp-sticky-atc--dismissed'), 350);
  });

  // Add to cart
  btn.addEventListener('click', async () => {
    const variantId = document.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (res.ok) {
        btn.textContent = '✓ Added';
        if (addedMsg) {
          addedMsg.classList.add('fp-sticky-atc__added--show');
          setTimeout(() => addedMsg.classList.remove('fp-sticky-atc__added--show'), 2500);
        }
        // Trigger Shopify cart refresh
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        fetch('/cart.js').then(r => r.json()).then(cart => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        });
        setTimeout(() => {
          btn.disabled = false;
          btn.textContent = 'Add to Cart';
        }, 2500);
      } else {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
    } catch {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    }
  });

  // Sync price with selected variant
  const updatePrice = () => {
    const selectedVariant = document.querySelector('.product-form__input input[type="radio"]:checked, [name="id"] option:checked');
    if (!selectedVariant || !priceEl) return;
    const form = document.querySelector('form[action="/cart/add"]');
    const priceContainer = form?.closest('[data-section]')?.querySelector('.price__regular .price-item--regular, .price .price-item--regular');
    if (priceContainer) priceEl.textContent = priceContainer.textContent.trim();
  };

  document.addEventListener('variant:changed', updatePrice);
  updatePrice();
})();
